// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2V93W","productName":"Table_productName__1PUB_"};